function MagnetImageContainer({ image, altText }: { image: string; altText: string }) {
  // TODO: replace every magnet image with this component
  return <img className="h-full w-full rounded-xl object-cover" src={image} alt={altText} />;
}
export default MagnetImageContainer;
